Ext.define('SA.TextMetrics', {
    extend: 'Ext.util.TextMetrics',

    constructor() {
        this.callParent(arguments);

        var measure = this.outerEl = this.measure;

        measure.setStyle({
            height: '100px',
            overflow: 'hidden',
            width: '100px'
        });

        this.measure =  measure.createChild({
            style: 'position:absolute'
        });
    },

    destroy(){
        this.outerEl.remove();

        this.outerEl = this.measure = this.el = null;
    },

    getHeights(text, widths) {
        var el = this.measure,
            heights = [],
            html = widths.map(width => `<div style="width:${width}px">${text}</div>`),
            node;

        el.update(html.join(''));

        for (node = el.dom.firstChild ; node ; node = node.nextSibling) {
            heights.push(Ext.fly(node).getHeight());
        }

        return heights;
    },

    getWidths(contents) {
        var el = this.measure,
            widths = [],
            html = contents.map(content => {
                return `<span style="white-space:nowrap;position:absolute">${content}</span>`;
            }),
            node;

        el.update(html.join(''));

        for (node = el.dom.firstChild ; node ; node = node.nextSibling) {
            widths.push(Ext.fly(node).getWidth());
        }

        return widths;
    },

    setStyle(property, value) {
        this.measure.setStyle(property, value);
    }
});
